import Vue from 'vue'
import Vuex from 'vuex'
import orderComponentModules from '@@/store/modules'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    ...orderComponentModules
  }
})

export default store
